import { useContext, useEffect } from 'react'
import { AuthenticationContext, consumeSeamlessAuthCredentials } from '@cloudmlm/cloudmlm-auth'
import { useNavigate, useParams } from 'react-router-dom'
import { endApiLoader, startApiLoader } from '../../services/apiLoaderService';
import urlConstant from '../../constants/urlConstants';

const SeamlessAuthProcessor = () => {
  const authenticationState = useContext(AuthenticationContext);
  const navigate = useNavigate();
  const {key} = useParams();

  useEffect(() => {
    startApiLoader();
    consumeSeamlessAuthCredentials(key, urlConstant.SeamlessLogin.SeamlessLoginConsume).then(result => {
      authenticationState.logUserIn(result);
      endApiLoader();
      navigate('/home');
    }).catch((e) => {
      console.error(e);
    });
  }, [key]);
};

export default SeamlessAuthProcessor;